import { render, staticRenderFns } from "./MusicMor.vue?vue&type=template&id=1b7938cc&scoped=true"
import script from "./MusicMor.vue?vue&type=script&lang=js"
export * from "./MusicMor.vue?vue&type=script&lang=js"
import style0 from "./MusicMor.vue?vue&type=style&index=0&id=1b7938cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7938cc",
  null
  
)

export default component.exports